import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppLayout from "./components/AppLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PropertiesPage from "./pages/PropertiesPage";
import AlertsPage from "./pages/AlertsPage";
import SettingsPage from "./pages/SettingsPage";
import UsersPage from "./pages/UsersPage";
import MapPage from "./pages/MapPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import ProgrammePage from "./pages/ProgrammePage";
import DeliveryPage from "./pages/DeliveryPage";
import JobCardInboxPage from "./pages/JobCardInboxPage";
import AuditLogPage from "./pages/AuditLogPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";
import CompliancePage from "./pages/CompliancePage";
import AccountPage from "./pages/AccountPage";
import GovernancePage from "./pages/GovernancePage";
import DpaTemplatePage from "./pages/DpaTemplatePage";
import DpaOrganisationPage from "./pages/DpaOrganisationPage";
import DpaAgreementPage from "./pages/DpaAgreementPage";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function SuperOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/properties" element={<Protected><PropertiesPage /></Protected>} />
            <Route path="/map" element={<Protected><MapPage /></Protected>} />
            <Route path="/analytics" element={<Protected><AnalyticsPage /></Protected>} />
            <Route path="/programme" element={<Protected><ProgrammePage /></Protected>} />
            <Route path="/delivery" element={<Protected><DeliveryPage /></Protected>} />
            <Route path="/inbox" element={<Protected><JobCardInboxPage /></Protected>} />
            <Route path="/audit" element={<Protected><AuditLogPage /></Protected>} />
            <Route path="/alerts" element={<Protected><AlertsPage /></Protected>} />
            <Route path="/users" element={<Protected><UsersPage /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/account" element={<Protected><AccountPage /></Protected>} />
            <Route path="/governance" element={<Protected><SuperOnly><GovernancePage /></SuperOnly></Protected>} />
            <Route path="/compliance" element={<Protected><SuperOnly><CompliancePage /></SuperOnly></Protected>} />
            <Route path="/compliance/templates/:id" element={<Protected><SuperOnly><DpaTemplatePage /></SuperOnly></Protected>} />
            <Route path="/compliance/organisations/:id" element={<Protected><SuperOnly><DpaOrganisationPage /></SuperOnly></Protected>} />
            <Route path="/compliance/agreements/:id" element={<Protected><SuperOnly><DpaAgreementPage /></SuperOnly></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
